import Immutable from 'immutable';
import { createSelector } from 'reselect';

export const getSuggestedCharities = (state) =>
  state.api.getIn(['normalized', 'result', 'participant', 'charities'], Immutable.List())
    .map((charityId) => state.api.getIn(['normalized', 'entities', 'charities', `${charityId}`], Immutable.Map()));

export const getCharitiesSearchResponse = (state) =>
  state.api.getIn(['normalized', 'result', 'charities'], Immutable.List())
    .map((charityId) => state.api.getIn(['normalized', 'entities', 'charities', `${charityId}`], Immutable.Map()));

export const getParticipantFirstName = (state) => state.api.getIn(['normalized', 'result', 'participant', 'participantFirstName']);

export const getParticipantLastName = (state) => state.api.getIn(['normalized', 'result', 'participant', 'participantLastName']);

export const getParticipantEmail = (state) => state.api.getIn(['normalized', 'result', 'participant', 'participantEmail']);

export const charitySearchEnabledSelector = (state) => state.api.getIn(['normalized', 'result', 'participant', 'charitySearchEnabled']);

export const getCharityId = (state) => state.mainStore.get('charityId');

export const getCharityEntities = (state) => state.api.getIn(['normalized', 'entities', 'charities'], Immutable.Map());

export const getParticipantPageName = (state) => state.api.getIn(['normalized', 'result', 'participant', 'pageName']);

export const getParticipantPageUrl = (state) => state.api.getIn(['normalized', 'result', 'participant', 'pageUrl']);

export const getDonationLocation = (state) => state.api.getIn(['normalized', 'result', 'participant', 'donationLocation']);
export const getEventId = (state) => state.api.getIn(['normalized', 'result', 'participant', 'eventId']);

export const getSelectedCharity = createSelector([getCharityId, getCharityEntities], (charityId, charityEntities) =>
  charityEntities.get(charityId, Immutable.Map()).toJS(),
);

export default {
  getSuggestedCharities,
  getCharitiesSearchResponse,
  getParticipantFirstName,
  getParticipantLastName,
  getParticipantEmail,
  charitySearchEnabledSelector,
  getCharityId,
  getCharityEntities,
};



// WEBPACK FOOTER //
// ./selectors/apiSelectors/apiSelectors.js